export default "__VITE_ASSET__7b3cfe66__"